module.exports = __webpack_public_path__ + "DINNextLTPro-HeavyCondensed.woff2?fb037ce0d2d9aad114b258b65031530c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-HeavyCondensed.woff2
// module id = 1427
// module chunks = 0